<div class="edp-card-widget card desktop">
    <div class="to-pay d-flex flex-column">
        <div class="card-header">
            <span class="card-title" [ngClass]="{'violet': balanceObject.balance < 0}">{{ 'pt.edp.edponline.payment.title' | translate }}</span>
            <span class="card-icon">
                <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
            </span>
        </div>
        <div class="card-body">
            <!-- SECÇÃO 1 -->
            <div class="period d-flex" [ngClass]="{'more-to-pay': debt && totalInvoices > 1}">
                <div class="my-auto">
                    <span class="value" *ngIf="value === '0'">
                        {{ value }} €
                    </span>
                    <span class="value" *ngIf="value !== '0'" [innerHTML]="balanceObject.balance | edpDecimalSplit"></span>
                </div>
                <div class="my-auto ml-auto" *ngIf="balanceObject.balance < 0">
                    <ng-container *ngTemplateOutlet="popoverTemplate"></ng-container>
                </div>
            </div>
            <!-- SECÇÃO 2 -->
            <span class="title" *ngIf="balanceObject.balance >= 0">{{ 'pt.edp.edponline.without.next.payment' | translate }}</span>
            <span class="title" *ngIf="balanceObject.balance < 0">{{ 'pt.edp.edponline.payment.period.title' | translate }}</span>
            <div class="period d-flex" [ngClass]="{'no-dd': !contract.HasDirectDebit}">
                <div class="my-auto" *ngIf="balanceObject.balance >= 0">
                    <span class="date">
                    {{ date | date: 'd MMMM y' }}
                    </span>
                </div>
                <ng-container *ngIf="balanceObject.balance < 0">
                    <div class="my-auto">
                        <span class="date">
                            {{ dateFrom |  date: 'd MMM y'}}
                            {{ 'pt.edp.edponline.payment.date' | translate }}
                            {{ dateTo |  date: 'd MMM y'}}
                        </span>
                    </div>
                    <div class="my-auto ml-auto">
                        <a [routerLink]="link">
                            <span class="more">{{ 'pt.edp.edponline.payment.period.see.detail' | translate }}</span>
                            <span class="d-inline-block align-middle mx-2">
                                <i class="icon-edponline-Bop-073 rotate-270 icon"  aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </ng-container>
            </div>
            <!-- SECÇÃO 3 -->
            <ng-container *ngIf="!contract.HasDirectDebit">
                <span class="conta-certa" *ngIf="contract?.HasContaCerta && !debt">7{{ 'pt.edp.edponline.payment.conta.certa' | translate }}</span>
                <div class="direct-debit">
                    <i class="icon-edponline-Bop-036 icon"  aria-hidden="true"></i>
                    <span class="description d-block" [innerHTML]="'pt.edp.edponline.payment.direct.debit.description' | translate"></span>
                    <a [routerLink]="linkDirectDebt">{{ 'pt.edp.edponline.payment.direct.debit.link.text' | translate }}</a>
                </div>
            </ng-container>

        </div>
        <ng-container *ngIf="contract.HasDirectDebit">
            <div class="card-footer">
                <div>
                    <div class="mb-4" *ngIf="contract?.BankName">
                        <span class="title-content">{{ 'pt.edp.edponline.payment.bank.title' | translate }}</span>
                        <span class="detail-content">{{ contract?.BankName}}</span>
                    </div>
                </div>
                <div class="iban-detail">
                    <span class="title-content">{{ 'pt.edp.edponline.payment.iban.title' | translate }}</span>
                    <span class="detail-content-mobile">{{ contract?.DirectDebitIban }}</span>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="payment-method">
        <edp-chart [balance]="balanceObject" [chartId]="'fullChart'" [fullCard]="true"></edp-chart>
    </div>
</div>

<div class="mobile">
    <edp-widget-chart-billing [chartId]="'cardChart'" [balance]="balanceObject"></edp-widget-chart-billing>
</div>


<ng-template #popoverTemplate>
    <edp-popover #popComponent [popoverContent]="popoverContent"
        [popBtn]="'icon icon-edponline-Bop-025'">
        <ng-template #popoverContent>
            <span class="d-block tooltip-text">
                <span class="violet">{{ balanceObject.balance | edpDotToComma }}{{ 'pt.edp.edponline.tooltip.value' | translate }}</span>{{ 'pt.edp.edponline.tooltip' | translate }}
            </span>
        </ng-template>
    </edp-popover>
</ng-template>
